import React, { useState, useEffect, useReducer, useCallback } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AddIcon from '@mui/icons-material/Add'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import Checkbox from '@mui/material/Checkbox'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import TextField from '@mui/material/TextField'
import { uploadFileData } from '../../actions/userActions'
import { closePopup } from '../../actions/uiActions'
import {
    getDataSources,
    saveDataToolsJob,
    dataToolsGetDimensions,
    dataToolsGetDimensionMembers,
    readColumnsFromZipEntry,
    dataToolsGetDimensionsComparison,
    dataToolsDeleteBlobsFromUnfinishedJob,
    readTablesFromExcel,
    readTablesFromExcelFiles,
    getTransformData,
    dataToolsGetMeasureAggregations
} from '../../actions/dbFunctionsActions'
import AddTaskList, { ALL_ACTIONS } from '../ui/tasks/AddTaskList'

function DataToolsTaskList(props) {
    const DB_JOB_TYPE = 2
    const MODE_NONE = ''
    const MODE_ADD = 'add'
    const MODE_EDIT = 'edit'

    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [savingJob, setSavingJob] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [ssisJobs, setSsisJobs] = useState([])
    const [mode, setMode] = useState(MODE_NONE)
    const [jobTasks, setJobTasks] = useState([])
    const [currentTask, setCurrentTask] = useState({})
    const [taskIndex, setTaskIndex] = useState(-1)
    const [currentJobId, setCurrentJobId] = useState(-1)
    const [currentJobName, setCurrentJobName] = useState('')
    const [currentJobDescription, setCurrentJobDescription] = useState('')
    const [taskValidated, setTaskValidated] = useState([])
    const [filesPresaved, setFilesPresaved] = useState([])
    const [globalFiles, setGlobalFiles] = useState([])
    const [teamIds, setTeamIds] = useState([])
    const [header, setHeader] = useState('Create Job')
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    // trigger on component mount
    useEffect(() => {
        setSqLDbList(props.popupInfo.databases)
        setSsisJobs(props.popupInfo.packages)

        if (props.popupInfo.jobData !== null) {
            setHeader('Edit Job')
            let jobData = JSON.parse(props.popupInfo.jobData.jobData)
            let newSteps = []
            let validated = []

            // Look for a matching element
            for (let x = 0; x < jobData.Tasks.length; x++) {
                for (let y = 0; y < ALL_ACTIONS.length; y++) {
                    if (ALL_ACTIONS[y]["key"] === jobData.Tasks[x]["Key"]) {
                        newSteps.push({ mode: ALL_ACTIONS[y]["name"], data: jobData.Tasks[x]["Value"] })
                        validated.push(ALL_ACTIONS[y].validateControl(jobData.Tasks[x]["Value"]))
                    }
                }
            }

            // Set files up
            if (jobData.Files && jobData.Files.length > 0) {
                setFilesPresaved(jobData.Files)
            }

            setCurrentJobId(props.popupInfo.jobData.id)
            setCurrentJobName(props.popupInfo.jobData.jobName)
            setCurrentJobDescription(props.popupInfo.jobData.jobDescription)
            setJobTasks(newSteps)
            setTaskValidated(validated)

            if (props.popupInfo.jobData.databaseJobs) {
                let copiedOverTeamIds = []

                for (let x = 0; x < props.popupInfo.jobData.databaseJobs.length; x++) {
                    copiedOverTeamIds.push(props.popupInfo.jobData.databaseJobs[x]["teamID"])
                }

                setTeamIds(copiedOverTeamIds)
            }
        }
        else {
            setHeader('Create Job')
            setMode(MODE_ADD)
        }

        if (props.popupInfo.globalFiles && props.popupInfo.globalFiles.length > 0) {
            let globals = []
            for (let x = 0; x < props.popupInfo.globalFiles.length; x++) {
                let individualJobFileData = JSON.parse(props.popupInfo.globalFiles[x]["jobFileData"])
                globals.push(individualJobFileData)
            }
            setGlobalFiles(globals)
        }
    }, [])

    function getJobStepId(stepMode) {
        // Look for a matching element
        for (let x = 0; x < ALL_ACTIONS.length; x++) {
            if (ALL_ACTIONS[x]["name"] === stepMode) {
                return ALL_ACTIONS[x]["key"]
            }
        }

        return 2
    }

    function removeStepAtIndex(index) {
        let copiedSteps = []
        let copiedValidated = []

        for (let x = 0; x < jobTasks.length; x++) {
            if (x !== index) {
                copiedSteps.push(jobTasks[x])
                copiedValidated.push(taskValidated[x])
            }
        }

        setJobTasks(copiedSteps)
        setTaskValidated(copiedValidated)
        setTaskIndex(-1)
        setMode(MODE_NONE)
    }

    function swapTaskIndex(index, newIndex) {
        console.log("swapTaskIndex", index, newIndex)
        // Shallow copies
        let copiedSteps = []
        let copiedValidated = []

        for (let x = 0; x < jobTasks.length; x++) {
            copiedSteps.push(jobTasks[x])
            copiedValidated.push(taskValidated[x])
        }

        // Actual Steps
        const taskInOldIndex = JSON.parse(JSON.stringify(copiedSteps[index]));
        const taskInNewIndex = JSON.parse(JSON.stringify(copiedSteps[newIndex]));
        copiedSteps[index] = taskInNewIndex
        copiedSteps[newIndex] = taskInOldIndex

        // Validated Steps
        const taskInOldValidatedIndex = JSON.parse(JSON.stringify(copiedValidated[index]));
        const taskInNewValidatedIndex = JSON.parse(JSON.stringify(copiedValidated[newIndex]));
        copiedValidated[index] = taskInNewValidatedIndex
        copiedValidated[newIndex] = taskInOldValidatedIndex
        
        // Update state
        setJobTasks(copiedSteps)
        setTaskValidated(copiedValidated)
        setTaskIndex(newIndex)
    }

    function handleClick(event) {
        event.preventDefault()

        // Job was not saved but files were uploaded
        if (currentJobId === -1 && filesPresaved.length > 0 && !savingJob) {
            let blobFiles = []
            for (let x = 0; x < filesPresaved.length; x++) {
                blobFiles.push(filesPresaved[x]["blobName"])
            }
            props.dataToolsDeleteBlobsFromUnfinishedJob()
        }

        props.closePopup()
    }

    function handleJobStepsSave(event) {
        event.preventDefault()
        let taskList = { "Files": filesPresaved, "Tasks": [] }
        setSavingJob(true)
        setIsLoadingRequest(true)

        // Build task list to put into JSON string
        for (let x = 0; x < jobTasks.length; x++) {
            taskList.Tasks.push({ "Key" : getJobStepId(jobTasks[x]["mode"]), "Value": jobTasks[x]["data"] })
        }

        props.saveDataToolsJob(DB_JOB_TYPE, JSON.stringify(taskList), currentJobId, currentJobName, currentJobDescription, teamIds)
        setIsLoadingRequest(false)
    }

    function renderSubmitButton() {
        if (isLoadingRequest) {
            return <button type="submit" className="btn" disabled onClick={() => {}}>Saving...</button>
        }

        let allTasksValid = true

        if (jobTasks.length === 0) {
            allTasksValid = false
        } else {
            for (let taskIterator = 0; taskIterator < jobTasks.length; taskIterator++) {

                for (let x = 0; x < ALL_ACTIONS.length; x++) {
                    if (ALL_ACTIONS[x]["name"] === jobTasks[taskIterator].mode) {
                        let validated = ALL_ACTIONS[x].validateControl(jobTasks[taskIterator].data)
                        if (!validated) {
                            allTasksValid = false
                        }
                    }
                }

            }
        }

        if (allTasksValid) {
            return <button type="submit" className="btn" onClick={handleJobStepsSave}>Save Job</button>
        } else {
            return <button type="submit" className="btn" disabled onClick={() => {}}>Jobs Invalid</button>
        }
    }

    function renderLeftPanelButton(task, index) {
        let foundMatch = false
        let icon = null
        let text = null
        let validated = null
        let isSelected = index === taskIndex

        // Look for a matching element
        for (let x = 0; x < ALL_ACTIONS.length; x++) {
            if (ALL_ACTIONS[x]["name"] === task.mode) {
                foundMatch = true
                icon = ALL_ACTIONS[x]["icon"]
                text = ALL_ACTIONS[x]["text"]
                validated = ALL_ACTIONS[x].validateControl(task.data)
            }
        }

        if (foundMatch) {
            return (<ListItemButton
            style={ isSelected ? { "backgroundColor": "rgba(0, 0, 0, 0.2)" } : {}}
            onClick={() => {
                setCurrentTask(task)
                setMode(MODE_EDIT)
                setTaskIndex(index)
            }}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={text} primaryTypographyProps={{ style: { color: (validated) ? "#000" : "#d32f2f" } }} />
            </ListItemButton>)
        } else {
            return null
        }
    }

    function renderRightPanel() {
        if (mode === MODE_ADD) {
            return <AddTaskList onSelect={(mode) => {
                let copied = jobTasks
                let copiedValidated = taskValidated

                copied.push({ mode: mode.name, data: mode.emptyDataItem })
                copiedValidated.push(false)

                setJobTasks(copied)
                setTaskValidated(copiedValidated)
                
                setCurrentTask({ mode: mode.name, data: mode.emptyDataItem })
                setMode(MODE_EDIT)
                setTaskIndex(copied.length - 1)
            }} />
        } else if (mode === MODE_EDIT) {
            // Look for a matching element
            let renderLogicStep = null
            let foundActionIndex = -1

            // Find the appropriate action
            for (let x = 0; x < ALL_ACTIONS.length; x++) {
                if (ALL_ACTIONS[x]["name"] === currentTask.mode) {
                    renderLogicStep = ALL_ACTIONS[x]
                    foundActionIndex = x
                }
            }
            
            // If we found a component, render it
            if (renderLogicStep !== null) {
                return renderLogicStep.renderMainComponent(
                    taskIndex,
                    filesPresaved.concat(globalFiles),
                    currentTask.data,
                    sqLDbList,
                    ssisJobs,
                    props.getDataSources,
                    props.dataToolsGetDimensions,
                    props.dataToolsGetDimensionMembers,
                    props.readColumnsFromZipEntry,
                    props.dataToolsGetDimensionsComparison,
                    props.readTablesFromExcel,
                    props.readTablesFromExcelFiles,
                    props.getTransformData,
                    props.dataToolsGetMeasureAggregations,
                    (data) => {
                        for (let x = 0; x < jobTasks.length; x++) {
                            if (x === taskIndex) {
                                jobTasks[x]["data"] = data
                                taskValidated[x] = ALL_ACTIONS[foundActionIndex].validateControl(data)
                                forceUpdate()
                            }
                        }
                })
            } else {
                return null
            }
        } else {
            return <h3>Task Infomation Found Here</h3>
        }
    }

    function removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
      }

    function renderTeamsCheckboxes() {
        let teams = props.teamList.filter(x => x.customer.id === parseInt(props.currentUser.customerID)).sort((a, b) => parseFloat(a.id) - parseFloat(b.id))

        if (props.role === "Builder") {
            let filteredTeams = []
            let allTeamIds = []

            for (let allTeamIndex = 0; allTeamIndex< teams.length; allTeamIndex++) {
                for (let userTeamIndex = 0; userTeamIndex < props.currentUser.applicationUserTeams.length; userTeamIndex++) {
                    if (teams[allTeamIndex]["id"] === props.currentUser.applicationUserTeams[userTeamIndex]["teamID"]) {
                        filteredTeams.push(teams[allTeamIndex])
                        allTeamIds.push(props.currentUser.applicationUserTeams[userTeamIndex]["teamID"])
                    }
                }
            }

            teams = filteredTeams

            if (teamIds.length === 0) {
                setTeamIds(allTeamIds)
            }
        }

        if (teams.length > 0) {
            return (<div className="field">
                <FormLabel component="legend">This job will be available to the following teams</FormLabel>
                {teams.map((x,i) => (
                    <FormControlLabel
                        key={`team-${i}`}
                        label={x.name}
                        control={
                            <Checkbox
                                checked={teamIds.includes(x.id)}
                                onChange={(e) => {
                                    e.preventDefault()
                                    let copiedTeamIds = teamIds
                                
                                    if (e.target.checked) {
                                        copiedTeamIds.push(x.id)
                                    } else {
                                        copiedTeamIds = removeItemOnce(copiedTeamIds, x.id)
                                    }
                                
                                    setTeamIds(copiedTeamIds)
                                    forceUpdate()
                                }
                            }/>}>
                    </FormControlLabel>
                ))}
            </div>)
        }
        return null
    }

    function shouldUpArrayBeEnabled(currentlySelectedIndex, allJobTasks) {
        if (allJobTasks.length > 1 && currentlySelectedIndex > 0) {
            return false
        }
        return true
    }

    function shouldDownArrayBeEnabled(currentlySelectedIndex, allJobTasks) {
        if (allJobTasks.length > 1 && currentlySelectedIndex < (allJobTasks.length-1) && currentlySelectedIndex !== -1) {
            return false
        }
        return true
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        fullScreen={false}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="datatools2"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {header}
            {' '}
        </DialogTitle>
        <DialogContent>
            <form className="form dbFunctions">
                <div className="field">
                    <TextField
                        fullWidth
                        label="Job Name"
                        variant="outlined"
                        value={currentJobName}
                        disabled={false}
                        onChange={(e) => { e.preventDefault(); setCurrentJobName(e.target.value); }} />
                </div>
                <div className="field">
                    <TextField
                        fullWidth
                        label="Job Description"
                        variant="outlined"
                        value={currentJobDescription}
                        disabled={false}
                        onChange={(e) => { e.preventDefault(); setCurrentJobDescription(e.target.value); }} />
                </div>
                {renderTeamsCheckboxes()}
                <div className="field">
                    Add Task
                    <IconButton onClick={() => setMode(MODE_ADD)}><AddIcon /></IconButton>
                </div>
                <div className="field">
                    <Grid container spacing={2}>
                        <Grid item xs={4}  style={{ "maxHeight": "500px", "overflowY": "auto", "border": "1px solid #D3D3D3" }}>
                            <h3>
                                Current Steps In Job
                                <IconButton disabled={shouldUpArrayBeEnabled(taskIndex, jobTasks)} onClick={() => swapTaskIndex(taskIndex, taskIndex-1)}><ArrowUpwardIcon /></IconButton>
                                <IconButton disabled={shouldDownArrayBeEnabled(taskIndex, jobTasks)} onClick={() => swapTaskIndex(taskIndex, taskIndex+1)}><ArrowDownwardIcon /></IconButton>
                            </h3>
                            <List>
                                { jobTasks.map((x, i) => {
                                    return (<ListItem
                                        key={`step-${i}`}
                                        secondaryAction={
                                            <IconButton edge="end" aria-label="comments" onClick={() => {
                                                removeStepAtIndex(i)
                                            }}>
                                            <DeleteIcon />
                                            </IconButton>
                                        }>
                                        { renderLeftPanelButton(x, i) }
                                    </ListItem>)
                                })}
                            </List>
                        </Grid>
                        <Grid item xs={8} style={{ "maxHeight": "500px", "overflowY": "auto", "border": "1px solid #D3D3D3" }}>
                            {renderRightPanel()}
                        </Grid>
                    </Grid>
                </div>
                <div className="field">
                    {renderSubmitButton()}
                </div>
            </form>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        role: state.users.role,
        teamList: state.users.teamList,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({
            closePopup,
            getDataSources,
            saveDataToolsJob,
            dataToolsGetDimensions,
            dataToolsGetDimensionMembers,
            uploadFileData,
            readColumnsFromZipEntry,
            dataToolsGetDimensionsComparison,
            dataToolsDeleteBlobsFromUnfinishedJob,
            readTablesFromExcel,
            readTablesFromExcelFiles,
            getTransformData,
            dataToolsGetMeasureAggregations
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataToolsTaskList)